import { useEffect } from 'react'

/**
 * A presentation window whose console is gone closes after this - unless the
 * console comes back first, as after a reload.
 */
export const ORPHAN_CLOSE_MS = 10000

/** Closes this window once the console it had (`synced`) is gone for good. */
export const useCloseWhenOrphaned = (
	synced: boolean,
	consolePresent: boolean
): void => {
	useEffect(() => {
		if (!synced || consolePresent) {
			return
		}
		const timer = window.setTimeout(() => window.close(), ORPHAN_CLOSE_MS)
		return () => window.clearTimeout(timer)
	}, [synced, consolePresent])
}
